module.exports = __webpack_public_path__ + "static/EnmTX_BosSimeon_L_C_cl-4b133c06845b876d51a042a4fcdea8be.gif";